import React from 'react'
import Ressources from './Ressources'
import Credit from './Credit'

const Footer = () => {
    return (
        <footer>
            <Ressources />
            <Credit />
        </footer>
    )
}

export default Footer
